import AutoloadViews from './../../AutoloadViews';
import VTooltip from 'v-tooltip';
import Toasted from 'vue-toasted';
import vSelect from 'vue-select';
import VueFilter from 'vue-filter';
import Vue from 'vue';

// Init Vue.
window.Vue = Vue;

//
Vue.use(VTooltip);
Vue.use(VueFilter);
Vue.component('v-select', vSelect)

$(() => Vue.use(Toasted, {
    //theme: 'bootstrap',
    position: 'bottom-right',
    duration: 5 * 1000,
}));

// Compile editor but without resources/js/common/canvas/editor/canvas/document which is the iframe.
AutoloadViews.load('common.canvas', require.context('./../', false, /\.(js|vue)$/));
AutoloadViews.load('common.canvas.editor', require.context('./', false, /\.(js|vue)$/));
AutoloadViews.load('common.canvas.editor.canvas', require.context('./canvas/', false, /\.(js|vue)$/));

// TODO Only compile admin for admin habitat, not for website visitors?

// Include CSS dependencies to edit blocks.
//require('./../../../../sass/common/canvas/bootstrapper.scss')
